import { CellContext } from '@tanstack/react-table';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';

export const textFieldRender = <T,>(info: CellContext<T, unknown>) => {
  const value = info.getValue();
  if (value === null || value === undefined || value === '') {
    return <EmptyValue />;
  }
  return value;
};
